import { api } from '../../DefaultService';
import { IPaginationParams } from '../../types';
import {
  ISportHallCreateProps,
  ISportHallFilterParams,
  ISportHallProps,
  ISportHallSimpleProps,
  ISportHallUpdateParams,
} from './types';

const ENDPOINT = '/v1/sports/halls';

export const createSportHallAsync = async (
  data: ISportHallCreateProps,
): Promise<ISportHallProps> => {
  return await api
    .post(ENDPOINT, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateSportHallAsync = async ({
  id,
  data,
}: ISportHallUpdateParams): Promise<ISportHallProps> => {
  return await api
    .put(`${ENDPOINT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getSportHallAsync = async (
  id: number,
): Promise<ISportHallProps> => {
  return await api
    .get(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteSportHallAsync = async (id: number): Promise<void> => {
  await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};

export const getSportHallsByLicenseAsync = async (
  pagination: IPaginationParams,
  filter: ISportHallFilterParams,
): Promise<ISportHallSimpleProps[]> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense`, {
      params: { ...pagination, ...filter },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getSportHallsByLicenseCountAsync = async (
  filter: ISportHallFilterParams,
): Promise<number> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense/count`, {
      params: { ...filter },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};
